import { Node, mergeAttributes } from '@tiptap/core';

const HtmlDiv = Node.create({
    name: 'htmlDiv',
    group: 'block',
    content: 'block*',

    parseHTML() {
        return [{ tag: 'div' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes(HTMLAttributes), 0];
    },
});

export { HtmlDiv };
